module.exports = __webpack_public_path__ + "media/images/icon/icon_f2-b3f489dbb70b92828febda75ad1fc557.png";